import { createPropStyling } from '../privatePropStylingUtils';
export const spaceCssAttrNames = ['margin', 'marginBottom', 'marginLeft', 'marginRight', 'marginTop', 'padding', 'paddingBottom', 'paddingLeft', 'paddingRight', 'paddingTop'];
export const spaceCssAttrAliases = {
  m: 'margin',
  mb: 'marginBottom',
  ml: 'marginLeft',
  mr: 'marginRight',
  mt: 'marginTop',
  p: 'padding',
  pb: 'paddingBottom',
  pl: 'paddingLeft',
  pr: 'paddingRight',
  pt: 'paddingTop'
};
export const spacePropStyling = createPropStyling(spaceCssAttrNames, spaceCssAttrAliases);
//# sourceMappingURL=spacePropStyling.js.map